<router-outlet></router-outlet>
<!-- Outside the outlet, so a message survives the navigation that often follows an action. -->
<app-notice />
